import React from "react";
// import SCORM_API from '../../core/scorm/SCORM_API';
import IframeMessenger from "./libs/IframeMessenger";

/* eslint-disable react/prop-types */

export default class ScormIframeWrapper extends React.Component {
  constructor(props) {
    super(props);
    // The SCORM package's own origin is known here (it's the iframe's src) —
    // use it to validate inbound postMessage events in IframeMessenger.
    let allowedOrigin = null;
    try {
      allowedOrigin = new URL(props.url, window.location.href).origin;
    } catch (e) {
      allowedOrigin = null;
    }
    this.IframeMessenger = new IframeMessenger(
      {
        onSetScore: this.onSetScore.bind(this),
        onSetProgress: this.onSetProgress.bind(this),
        onSetSuccessStatus: this.onSetSuccessStatus.bind(this),
        onSetCompletionStatus: this.onSetCompletionStatus.bind(this),
      },
      { allowedOrigin }
    );
    this.IframeMessenger.init();
  }
  render() {
    return (
      <iframe
        src={this.props.url + "?idealStudio=" + this.props.id}
        sandbox="allow-scripts allow-same-origin allow-popups allow-forms allow-modals allow-downloads allow-popups-to-escape-sandbox allow-top-navigation-by-user-activation"
        style={{ width: "100%", height: "100%", zIndex: 0, border: "none" }}
        objecttype="scormpackage"
        webkitAllowFullScreen="true"
        allowFullScreen="true"
        mozallowfullscreen="true"
      />
    );
  }

  onSetScore(score, origin) {
    let attempted = this.props.exercises && this.props.exercises.attempted;
    try {
      let myurl = origin.split("?idealStudio=");
      let id = myurl[1];
      if (this.props.id === id && !attempted) {
        this.props.setAnswer(score);
      }
    } catch (e) {}
  }
  onSetProgress(progress, origin) {
    // Do nothing
  }
  onSetSuccessStatus(status, origin) {
    // Do nothing
  }
  onSetCompletionStatus(status, origin) {
    // Do nothing
  }
}
/* eslint-enable react/prop-types */
